import axios from "axios";

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL + "/api",
    withCredentials: true,
    withXSRFToken: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
};

const fetchCSRFToken = async () => {
    try {
        await apiClient.get(`${process.env.REACT_APP_API_URL}/api/csrf-cookie`, {
            withCredentials: true,
        });

        setTimeout(() => {
            const xsrfToken = getCookie("XSRF-TOKEN");
            if (xsrfToken) {
                localStorage.setItem("csrf_token", xsrfToken);
            } else {
                console.log("CSRF token not found in cookies.");
            }
        }, 1000);
    } catch (err) {
        console.error("Error fetching CSRF token:", err);
    }
};

apiClient.interceptors.request.use(
    async (config) => {
        try {
            const authToken = localStorage.getItem("auth_token");
            const method = config.method?.toLowerCase();

            const modifyingRequest = ["post", "put", "patch", "delete"].includes(method);
            const xsrfExists = getCookie("XSRF-TOKEN");

            if (modifyingRequest && !xsrfExists) {
                await fetchCSRFToken();
            }

            const xsrfToken = getCookie("XSRF-TOKEN");
            if (xsrfToken) {
                config.headers["X-XSRF-TOKEN"] = xsrfToken;
            }

            if (authToken) {
                config.headers["Authorization"] = `Bearer ${authToken}`;
            }
        } catch (err) {
            console.log("Request without CSRF or Authorization due to error:", err);
        }

        return config;
    },
    (error) => Promise.reject(error)
);

export default apiClient;
